import useSentryLogger from 'hooks/useSentryLogger';
import { useEffect, useRef } from 'react';
import { useAppSelector } from 'redux/hooks';
import reportWebVitals from 'reportWebVitals';
import { MetricType } from 'web-vitals';

const CLS_VALUE_THRESHOLD = 0.09;

const useCLSToSentryLog = () => {
    const logger = useSentryLogger();
    const ecom = useAppSelector((state) => state.ecoms.selected);
    const ecomRef = useRef(ecom);

    useEffect(() => {
        ecomRef.current = ecom;
    }, [ecom]);

    useEffect(() => {
        const handleWebVitals = (metric: MetricType) => {
            if (metric.name === 'CLS' && metric.value > CLS_VALUE_THRESHOLD) {
                const entries = (metric.entries ?? []).flatMap((entry) =>
                    (entry.sources ?? []).map((source) => {
                        const node = source.node as unknown as Element | null;

                        return {
                            value: entry.value,
                            textContent: node?.textContent?.slice(0, 200) ?? '',
                            classList: node?.classList ? Array.from(node.classList).join(' ') : '',
                            id: node?.id ?? '',
                        };
                    })
                );

                if (entries.length > 0) {
                    logger.warn('CLS layout shift', {
                        value: metric.value,
                        entries: JSON.stringify(entries),
                        page: window.location.pathname,
                        ecom: ecomRef.current?.domain ?? '',
                    });
                }
            }
        };

        reportWebVitals(handleWebVitals, { reportAllChanges: true });
    }, [logger]);
};

export default useCLSToSentryLog;
